<template>
  <page-table />
</template>
<script>
import PageTable from './components/order-table'
export default {
  name: 'technology-techGoodsCutting',
  components: {
    PageTable,
  },
}
</script>